
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio,Datetime, wx
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
dateStatus:false,
searchPop:false,
loadmoreText:'正在加载。。。',
busy:false,
endDate:'',
startDate:'',
dateKey:0,
keyword:'',
name:'',
phone:'',
index:0,
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
}
},
created(){
this.startDate = '';
this.endDate = '';
this.name = '';
this.phone = '';
this.config();

},
amount(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
resetSearch(){
this.name = '';
this.phone = '';
this.keyword = '';
this.startDate = '';
this.endDate = '';
this.dateStatus = false;
this.dateKey++;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
this.searchPop = false;
},
searchSubmit(){
this.lastId = 0;
this.pageFlag = 2;
this.list = [];
this.loadmore();
this.searchPop = false;
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
this.dateKey++;
},
getList(){
this.$api.washCode({state:5,last_id:this.lastId,page_flag:this.pageFlag,keyword:this.keyword,up_start:this.startDate,up_end:this.endDate,name:this.name,phone:this.phone}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
that.keyword = res.resultStr.split(',')[1];
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/upList.vue